<template>
  <div class="documento-detalhes" id="odin-documento-detalhes">
    <div class="card mb-4">
      <div class="card-header">
        <h4 class="mb-0">Documento Principal</h4>
      </div>
      <div class="card-body">
        <div class="row">
          <div class="col-md-6">
            <dl class="row">
              <dt class="col-sm-4">Natureza do documento:</dt>
              <dd class="col-sm-8">{{ getNaturezaDocumento }}</dd>

              <dt class="col-sm-4">Classificação:</dt>
              <dd class="col-sm-8">{{ getClassificacaoDocumento }}</dd>

              <dt class="col-sm-4">Emissor:</dt>
              <dd class="col-sm-8">{{ documento.nomeEmissor }}</dd>

              <dt class="col-sm-4">CNPJ Emissor:</dt>
              <dd class="col-sm-8">{{ documento.cnpjEmissor }}</dd>

              <dt class="col-sm-4">Data de emissão:</dt>
              <dd class="col-sm-8">{{ formatarData(documento.dataEmissao) }}</dd>
            </dl>
          </div>
          <div class="col-md-6">
            <dl class="row">
              <dt class="col-sm-4">Identificação:</dt>
              <dd class="col-sm-8">{{ documento.identificacaoDocumento }}</dd>

              <dt class="col-sm-4">Selo:</dt>
              <dd class="col-sm-8">{{ documento.seloAutenticidade }}</dd>

              <dt class="col-sm-4">Data do selo:</dt>
              <dd class="col-sm-8">{{ formatarData(documento.dataSelo) }}</dd>

              <dt class="col-sm-4">CNS:</dt>
              <dd class="col-sm-8">{{ documento.cns }}</dd>

              <dt class="col-sm-4">UF:</dt>
              <dd class="col-sm-8">{{ documento.ufEmissao }}</dd>
            </dl>
          </div>
        </div>
        <div class="row mt-3">
          <div class="col-12">
            <dl class="row">
              <dt class="col-sm-2">Descrição:</dt>
              <dd class="col-sm-10">{{ documento.descricaoPersonalizada }}</dd>
            </dl>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <dl class="row">
              <dt class="col-sm-4">Tipo de assinatura:</dt>
              <dd class="col-sm-8">{{ getTipoAssinatura }}</dd>
            </dl>
          </div>
          <div class="col-md-6" v-if="documento.tipoAssinatura === 2">
            <dl class="row">
              <dt class="col-sm-4">Assinador Digital:</dt>
              <dd class="col-sm-8">{{ getAssinadorDigital }}</dd>

              <dt class="col-sm-4">Hash:</dt>
              <dd class="col-sm-8">
                <small class="text-muted">{{ documento.hashValidacao }}</small>
              </dd>
            </dl>
          </div>
        </div>
      </div>
    </div>

    <!-- Negócios -->
    <div class="card mb-4" v-if="Object.keys(negocios).length > 0">
      <div class="card-header">
        <h4 class="mb-0">Negócios Jurídicos</h4>
      </div>
      <div class="card-body">
        <div v-for="(negocio, index) in negocios" :key="index" class="mb-4">
          <h5 class="border-bottom pb-2">Negócio #{{ negocio.sequencial }}</h5>
          <div class="row">
            <div class="col-md-6">
              <dl class="row">
                <dt class="col-sm-4">Tipo de ato:</dt>
                <dd class="col-sm-8">{{ getTipoAto(negocio.tipoAto) }}</dd>

                <dt class="col-sm-4">Valor do negócio:</dt>
                <dd class="col-sm-8">{{ formatarValor(negocio.valorNegocio) }}</dd>

                <dt class="col-sm-4">Valor fiscal:</dt>
                <dd class="col-sm-8">{{ formatarValor(negocio.valorFiscal) }}</dd>
              </dl>
            </div>
            <div class="col-md-6">
              <dl class="row" v-if="negocio.observacoes">
                <dt class="col-sm-4">Observações:</dt>
                <dd class="col-sm-8">{{ negocio.observacoes }}</dd>
              </dl>
            </div>
          </div>

          <!-- Imóveis do negócio -->
          <div v-if="negocio.imoveis && negocio.imoveis.length > 0" class="mt-3">
            <h6 class="text-secondary">Imóveis</h6>
            <div class="table-responsive">
              <table class="table table-sm  table-striped">
                <thead class="">
                  <tr>
                    <th>Matrícula</th>
                    <th>Tipo</th>
                    <th>Localização</th>
                    <th>Endereço</th>
                    <th>Cidade/UF</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(imovel, idx) in negocio.imoveis" :key="idx">
                    <td>{{ imovel.numeroMatricula }}</td>
                    <td>{{ getTipoImovel(imovel.tipoImovel) }}</td>
                    <td>{{ getLocalizacaoImovel(imovel.localizacao) }}</td>
                    <td>
                      {{ imovel.logradouro }}, {{ imovel.numero }}
                      <span v-if="imovel.unidade"> - {{ imovel.unidade }}</span>
                      <span v-if="imovel.bairro">, {{ imovel.bairro }}</span>
                    </td>
                    <td>{{ imovel.cidade }}/{{ imovel.uf }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <button class="btn btn-outline-primary btn-sm mt-2" @click="toggleDetalhesImovel(negocio.sequencial)">
              {{ detalhesImovelAberto[negocio.sequencial] ? 'Ocultar detalhes' : 'Ver mais detalhes' }}
            </button>

            <div v-if="detalhesImovelAberto[negocio.sequencial]" class="mt-3">
              <div v-for="(imovel, idx) in negocio.imoveis" :key="'det-'+idx" class="card mb-2">
                <div class="card-header">
                  <strong>Imóvel {{ idx+1 }}: {{ getTipoImovel(imovel.tipoImovel) }}</strong>
                </div>
                <div class="card-body">
                  <div class="row">
                    <div class="col-md-6">
                      <dl class="row mb-0">
                        <dt class="col-sm-4">Livro:</dt>
                        <dd class="col-sm-8">{{ getLivro(imovel.livro) }}</dd>

                        <dt class="col-sm-4">Edificação:</dt>
                        <dd class="col-sm-8">{{ getEdificacao(imovel.edificacao) }}</dd>

                        <dt class="col-sm-4">Lote:</dt>
                        <dd class="col-sm-8">{{ imovel.lote || '-' }}</dd>

                        <dt class="col-sm-4">Quadra:</dt>
                        <dd class="col-sm-8">{{ imovel.quadra || '-' }}</dd>
                      </dl>
                    </div>
                    <div class="col-md-6">
                      <dl class="row mb-0">
                        <dt class="col-sm-4">IPTU:</dt>
                        <dd class="col-sm-8">{{ imovel.iptu || '-' }}</dd>

                        <dt class="col-sm-4">CCIR:</dt>
                        <dd class="col-sm-8">{{ imovel.ccir || '-' }}</dd>

                        <dt class="col-sm-4">NIRF:</dt>
                        <dd class="col-sm-8">{{ imovel.nirf || '-' }}</dd>

                        <dt class="col-sm-4">Torre:</dt>
                        <dd class="col-sm-8">{{ imovel.torre || '-' }}</dd>
                      </dl>
                    </div>
                  </div>
                  <div class="row mt-2" v-if="imovel.descricaoImovel">
                    <div class="col-12">
                      <h6>Descrição:</h6>
                      <p class="mb-0">{{ imovel.descricaoImovel }}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Partes do negócio -->
          <div v-if="negocio.partes && negocio.partes.length > 0" class="mt-3">
            <h6 class="text-secondary">Partes Envolvidas</h6>
            <div class="table-responsive">
              <table class="table table-sm  table-striped">
                <thead class="">
                  <tr>
                    <th>Nome</th>
                    <th>CPF/CNPJ</th>
                    <th>Qualificação</th>
                    <th>Fração</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(parte, idx) in negocio.partes" :key="idx">
                    <td>{{ parte.nome }}</td>
                    <td>{{ parte.cpfCnpj }}</td>
                    <td>{{ getQualificacao(parte.qualificacao) }}</td>
                    <td>{{ parte.fracao ? (parte.fracao * 100).toFixed(2) + '%' : '-' }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Financiamento -->
    <div class="card mb-4" v-if="financiamentos.length > 0">
      <div class="card-header">
        <h4 class="mb-0">Financiamento</h4>
      </div>
      <div class="card-body">
        <div v-for="(financiamento, index) in financiamentos" :key="index" class="mb-3">
          <div class="row">
            <div class="col-md-6">
              <dl class="row">
                <dt class="col-sm-4">Valor do financiamento:</dt>
                <dd class="col-sm-8">{{ formatarValor(financiamento.valorFinanciamento) }}</dd>

                <dt class="col-sm-4">Enquadramento:</dt>
                <dd class="col-sm-8">{{ getEnquadramento(financiamento.enquadramento) }}</dd>

                <dt class="col-sm-4">Sistema de amortização:</dt>
                <dd class="col-sm-8">{{ getSistemaAmortizacao(financiamento.sistemaAmortizacao) }}</dd>

                <dt class="col-sm-4">Origem dos recursos:</dt>
                <dd class="col-sm-8">{{ getOrigemRecursos(financiamento.origemRecursos) }}</dd>
              </dl>
            </div>
            <div class="col-md-6">
              <dl class="row">
                <dt class="col-sm-4">Juros anual:</dt>
                <dd class="col-sm-8">{{ financiamento.jurosAnualNominal }}%</dd>

                <dt class="col-sm-4">Juros mensal:</dt>
                <dd class="col-sm-8">{{ financiamento.jurosMensalNominal }}%</dd>

                <dt class="col-sm-4">Prazo de carência:</dt>
                <dd class="col-sm-8">{{ financiamento.prazoCarencia }} dias</dd>

                <dt class="col-sm-4">Prazo de amortização:</dt>
                <dd class="col-sm-8">{{ financiamento.prazoAmortizacao }} meses</dd>
              </dl>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6">
              <dl class="row">
                <dt class="col-sm-4">Primeira parcela:</dt>
                <dd class="col-sm-8">
                  {{ formatarValor(financiamento.valorPrimeiraParcela) }}
                  ({{ formatarData(financiamento.dataPrimeiraParcela) }})
                </dd>

                <dt class="col-sm-4">Valor de avaliação:</dt>
                <dd class="col-sm-8">{{ formatarValor(financiamento.valorAvaliacao) }}</dd>
              </dl>
            </div>
            <div class="col-md-6">
              <dl class="row">
                <dt class="col-sm-4">Valor para despesas:</dt>
                <dd class="col-sm-8">{{ formatarValor(financiamento.valorFinanciadoDespesas) }}</dd>

                <dt class="col-sm-4">IOF financiado:</dt>
                <dd class="col-sm-8">{{ formatarValor(financiamento.iofFinanciado) }}</dd>
              </dl>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Garantias -->
    <div class="card mb-4" v-if="garantias.length > 0">
      <div class="card-header">
        <h4 class="mb-0">Garantias</h4>
      </div>
      <div class="card-body">
        <div class="table-responsive">
          <table class="table table-striped ">
            <thead>
              <tr>
                <th>Tipo</th>
                <th>Valor</th>
                <th>Matrícula</th>
                <th>Percentual</th>
                <th>Bem</th>
                <th>Grau</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(garantia, index) in garantias" :key="index">
                <td>{{ getTipoGarantia(garantia.tipoGarantia) }}</td>
                <td>{{ formatarValor(garantia.valorGarantia) }}</td>
                <td>{{ garantia.matriculaRegistro }}</td>
                <td>{{ garantia.percentualComprometido }}%</td>
                <td>{{ getTipoBem(garantia.tipoBem) }}</td>
                <td>{{ garantia.grauGarantia }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <!-- Venda e Compra -->
    <div class="card mb-4" v-if="vendasCompras.length > 0">
      <div class="card-header">
        <h4 class="mb-0">Venda e Compra</h4>
      </div>
      <div class="card-body">
        <div v-for="(vendaCompra, index) in vendasCompras" :key="index" class="mb-3">
          <div class="row">
            <div class="col-md-6">
              <dl class="row">
                <dt class="col-sm-5">Valor total:</dt>
                <dd class="col-sm-7">{{ formatarValor(vendaCompra.valorTotalVendaCompra) }}</dd>

                <dt class="col-sm-5">Valor financiamento:</dt>
                <dd class="col-sm-7">{{ formatarValor(vendaCompra.valorFinanciamento) }}</dd>

                <dt class="col-sm-5">Recursos próprios:</dt>
                <dd class="col-sm-7">{{ formatarValor(vendaCompra.recursosProprios) }}</dd>

                <dt class="col-sm-5">Financiamento FAR:</dt>
                <dd class="col-sm-7">{{ formatarValor(vendaCompra.financiamentoFAR) }}</dd>
              </dl>
            </div>
            <div class="col-md-6">
              <dl class="row">
                <dt class="col-sm-5">Subsídios:</dt>
                <dd class="col-sm-7">{{ formatarValor(vendaCompra.subsidios) }}</dd>

                <dt class="col-sm-5">FGTS:</dt>
                <dd class="col-sm-7">{{ formatarValor(vendaCompra.fgts) }}</dd>

                <dt class="col-sm-5">Outros recursos:</dt>
                <dd class="col-sm-7">{{ formatarValor(vendaCompra.outrosRecursos) }}</dd>
              </dl>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6">
              <dl class="row">
                <dt class="col-sm-5">Primeira aquisição:</dt>
                <dd class="col-sm-7">{{ vendaCompra.primeiraAquisicao ? 'Sim' : 'Não' }}</dd>
              </dl>
            </div>
            <div class="col-md-6" v-if="vendaCompra.recursosEspecie">
              <dl class="row">
                <dt class="col-sm-5">Valor em espécie:</dt>
                <dd class="col-sm-7">{{ formatarValor(vendaCompra.valorEspecie) }}</dd>

                <dt class="col-sm-5">CPF detentor:</dt>
                <dd class="col-sm-7">{{ vendaCompra.cpfDetentorRecursos }}</dd>
              </dl>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Impostos -->
    <div class="card mb-4" v-if="impostos.length > 0">
      <div class="card-header">
        <h4 class="mb-0">Impostos</h4>
      </div>
      <div class="card-body">
        <div class="table-responsive">
          <table class="table table-striped ">
            <thead>
              <tr>
                <th>Tipo</th>
                <th>Número da guia</th>
                <th>Valor pago</th>
                <th>Isento</th>
                <th>Justificativa</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(imposto, index) in impostos" :key="index">
                <td>{{ getTipoImposto(imposto.tipoImposto) }}</td>
                <td>{{ imposto.numeroInscricao }}</td>
                <td>{{ formatarValor(imposto.valorPago) }}</td>
                <td>
                  <span v-if="imposto.isento">Sim</span>
                  <span v-else>Não</span>
                </td>
                <td>{{ imposto.justificativa || '-' }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'OdinDocumentoDetalhesComponent',

  props: {
    documentoDetalhes: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      detalhesImovelAberto: {}
    }
  },

  computed: {
    documento() {
      return this.documentoDetalhes.documento || {};
    },

    negocios() {
      return this.documentoDetalhes.negocios || {};
    },

    financiamentos() {
      return this.documentoDetalhes.financiamentos || [];
    },

    garantias() {
      return this.documentoDetalhes.garantias || [];
    },

    vendasCompras() {
      return this.documentoDetalhes.vendasCompras || [];
    },

    impostos() {
      return this.documentoDetalhes.impostos || [];
    },

    getNaturezaDocumento() {
      const naturezas = {
        1: "Instrumento Particular com Força de Escritura Pública",
        3: "Instrumento Particular"
      };
      return naturezas[this.documento.naturezaDocumento] || '-';
    },

    getClassificacaoDocumento() {
      const classificacoes = {
        1: "Escritura de Compra e Venda",
        2: "Certidão",
        3: "Ofício",
        4: "Procuração",
        5: "Contrato de Financiamento",
        6: "Contrato de Alienação Fiduciária",
        7: "Cédula de Crédito",
        8: "Certidão de Registro",
        9: "Requerimento",
        10: "Aditamento Contratual",
        11: "Carta de Arrematação",
        12: "Mandado Judicial",
        13: "Instrumento de Doação",
        14: "Instrumento de Cessão de Direitos",
        15: "Notificação",
        16: "Outro"
      };
      return classificacoes[this.documento.classificacaoDocumento] || '-';
    },

    getTipoAssinatura() {
      const tipos = {
        1: "Física",
        2: "Digital"
      };
      return tipos[this.documento.tipoAssinatura] || '-';
    },

    getAssinadorDigital() {
      const assinadores = {
        1: "e-Notariado",
        2: "Assinador ONR",
        3: "Assinador RegistroImoveis",
        4: "Gov.br",
        5: "Outro"
      };
      return assinadores[this.documento.assinadorDigital] || '-';
    }
  },

  methods: {
    formatarData(data) {
      if (!data) return '-';
      const options = { day: '2-digit', month: '2-digit', year: 'numeric' };
      try {
        // Aqui convertemos uma string ISO para Date, se necessário
        const dateObj = typeof data === 'string' ? new Date(data) : data;
        return dateObj.toLocaleDateString('pt-BR', options);
      } catch (e) {
        return data; // Retorna o original se falhar
      }
    },

    formatarValor(valor) {
      if (valor === undefined || valor === null) return '-';
      return new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: 'BRL'
      }).format(valor);
    },

    getTipoAto(codigo) {
      const tipos = {
        1: "Venda e compra",
        2: "Hipoteca",
        3: "Alienação fiduciária",
        4: "Portabilidade",
        6: "Averbação de CCI",
        8: "Abertura de Limite de Crédito",
        9: "Compromisso de venda e compra",
        10: "Doação",
        18: "Aditamento",
        19: "Abertura de Limite de Crédito CPR"
      };
      return tipos[codigo] || '-';
    },

    getTipoImovel(codigo) {
      const tipos = {
        1: "Apartamento",
        2: "Área de Terra",
        3: "Área de terras",
        4: "Armazém",
        5: "Bangalô",
        6: "Barracão",
        7: "Casa de moradia",
        8: "Chácara",
        9: "Chalé",
        10: "Cômodo comercial",
        11: "Conjunto",
        12: "Depósito",
        13: "Edícula",
        14: "Fazenda",
        15: "Galpão",
        16: "Garagem",
        17: "Gleba de terra",
        18: "Kitchenette",
        19: "Loja",
        20: "Prédio",
        21: "Prédio comercial",
        22: "Prédio p/ indústria",
        23: "Prédio residencial",
        24: "Quinhão de terra",
        25: "Rua particular",
        26: "Sala",
        27: "Salão",
        28: "Sítio",
        29: "Sobreloja",
        30: "Terreno/Lote",
        31: "Unid. res. autônoma",
        32: "Unidade Autônoma",
        33: "Unidade residencial"
      };
      return tipos[codigo] || '-';
    },

    getLocalizacaoImovel(codigo) {
      const localizacoes = {
        1: "Urbano",
        2: "Rural"
      };
      return localizacoes[codigo] || '-';
    },

    getLivro(codigo) {
      const livros = {
        1: "Lv.2-Registro Geral (matrícula)",
        2: "Transcrição das Transmissões",
        3: "Lv.3-Registro Auxiliar"
      };
      return livros[codigo] || '-';
    },

    getEdificacao(codigo) {
      const edificacoes = {
        0: "Não se aplica",
        1: "Construído",
        2: "Em construção"
      };
      return edificacoes[codigo] || '-';
    },

    getQualificacao(codigo) {
      const qualificacoes = {
        1001: "Adquirente",
        1002: "Avalista",
        1003: "Credor",
        1004: "Depositário",
        1005: "Devedor",
        1008: "Interessado",
        1009: "Interveniente",
        1010: "Proprietário",
        1012: "Transmitente",
        1013: "Anuente",
        1014: "Representante (por procuração)",
        1016: "Emitente",
        1017: "Fiel depositário",
        1018: "Garantidor",
        1019: "Cedente",
        1020: "Cessionário",
        1021: "Fiador"
      };
      return qualificacoes[codigo] || '-';
    },

    getEnquadramento(codigo) {
      const enquadramentos = {
        1: "SFH",
        2: "Fora do SFH",
        3: "PMCMV",
        4: "SFI",
        5: "Outro",
        6: "Casa Verde Amarela",
        7: "Crédito com garantia de imóvel",
        8: "FGTS Procotista",
        9: "FGTS Habitação popular"
      };
      return enquadramentos[codigo] || '-';
    },

    getSistemaAmortizacao(codigo) {
      const sistemas = {
        1: "SAC",
        2: "SACRE",
        3: "PRICE",
        4: "Outro",
        5: "Complementar em informações gerais"
      };
      return sistemas[codigo] || '-';
    },

    getOrigemRecursos(codigo) {
      const origens = {
        1: "Não utiliza",
        2: "FAR",
        3: "FGTS",
        4: "FGTS/UNIÃO",
        5: "SBPE",
        6: "Privados/Próprios"
      };
      return origens[codigo] || '-';
    },

    getTipoGarantia(codigo) {
      const tipos = {
        1: "Alienação Fiduciária",
        2: "Hipoteca",
        3: "Penhor",
        4: "Caução",
        5: "Outras"
      };
      return tipos[codigo] || '-';
    },

    getTipoBem(codigo) {
      const tipos = {
        1: "Imóvel urbano residencial",
        2: "Imóvel urbano comercial",
        3: "Imóvel rural",
        4: "Veículo",
        5: "Outros"
      };
      return tipos[codigo] || '-';
    },

    getTipoImposto(codigo) {
      const tipos = {
        1: "ITBI",
        2: "ITCMD",
        3: "Outros"
      };
      return tipos[codigo] || '-';
    },

    toggleDetalhesImovel(negocioId) {
      this.$set(this.detalhesImovelAberto, negocioId, !this.detalhesImovelAberto[negocioId]);
    }
  }
}
</script>

<style lang="scss">

#odin-documento-detalhes {
  dt {
    font-weight: 600;
  }

  dd {
    margin-bottom: 0.5rem;
  }

  .table-responsive {
    max-height: 400px;
    overflow-y: auto;
  }

  .table th {
    position: sticky;
    top: 0;
    z-index: 1;
  }
}

</style>
